import { ReportPrinter } from "../domain/page";
import {nextTick} from '@/modules/report_server/infra/next_tick'
interface ReportApi {
    printReport(batchIndex:number,numBatcher:number): Promise<void>;
}
declare global {
    interface Window {
        reportApi?: ReportApi;
    }
}
export class Vue2ReportPrinter implements ReportPrinter {
  async print(batchIndex:number, numBatches:number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        console.log("Printing report...");
        nextTick(async () => {
            if(window.reportApi){
                await window.reportApi.printReport(batchIndex,numBatches);
            }else{
                await(new Promise(res => setTimeout(res, 3000)))
                console.log('no reportApi found in window object.')
            }
            resolve()
        });
    });
    
  }
}